import { makeServiceHeaders } from "@coworker/app/src/core/hooks/fetch.helpers";
import { useQuery } from "@tanstack/react-query";
import { CORE_SERVICE_URL } from "@coworker/app/src/hooks/API/core.service";

async function getAPIKey() {
  const url = `${CORE_SERVICE_URL}/product-search/api-key`;
  const response = await fetch(url, {
    method: "GET",
    headers: await makeServiceHeaders(),
  });

  if (!response.ok) {
    console.error(
      "Failed to fetch API key",
      response.status,
      response.statusText
    );
    throw new Error(`Failed to fetch API key: ${response.status}`);
  }

  return await response.text();
}

export const useGetAPIKey = () => {
  return useQuery({
    queryKey: ["product-search-api-key"],
    queryFn: getAPIKey,
    staleTime: 1000 * 60 * 60, // 1 hour
    gcTime: 1000 * 60 * 60, // 1 hour
  });
};
